import React from 'react';
import Sidebar from './Sidebar';
import UserHeader from './UserHeader';

const Layout = ({ children }) => {
  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <UserHeader />
      <div style={{ 
        marginLeft: '250px', 
        width: 'calc(100% - 250px)',
        minHeight: '100vh',
        background: '#f8f9fa',
        paddingTop: '60px'
      }}>
        {children}
      </div>
    </div>
  );
};

export default Layout;